module.exports = __webpack_public_path__ + "img/standardRLQD.02039556.png";